const UaeMpciKeys = {
  TITLE: "title",
  FILING_OPERATOR: "filingOperator",
  UAE_FF_MPCI_PARTY_ID: "uaeFFMpciPartyId",
  DOCUMENT_TYPE: "documentType",
  BILL_NO: "billNo",
  PARENT_BILL_NO: "parentBillNo",
  ORIGINAL_BILL_NO: "originalBillNo",
  FUNCTION_TYPE: "functionType",
  REASON_FOR_UPDATING_FILING: "reasonForUpdatingFiling",
  PROCESSING_INDICATOR: "processingIndicator",
  BOL_ISSUE_DATE: "bolIssueDate",
  SOB_DATE: "sobDate",
  PLACE_OF_BILL_ISSUE_COUNTRY: "placeOfBillIssueCountry",
  BILL_ISSUE_LOCATION_NAME: "billIssueLocationName",
  FREIGHT_PAYABLE_COUNTRY: "freightPayableCountry",
  FREIGHT_LOCATION_NAME: "freightLocationName",
  SHIPMENT_TYPE: "shipmentType",
  SHIPMENT_DESCRIPTION: "shipmentDescription",
  TOTAL_FF_BILLS: "totalFFBills",
  FILING_OPERATOR_MPCI_PARTY_ID: "filingOperatorMpciPartyId",
  STATUS: "status",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  UPDATED_BY: "updatedBy",
  UPDATED_DATE: "updatedDate",
  SUBMITTED_BY: "submittedBy",
  SUBMITTED_DATE: "submittedDate",
  UPDATE_BUTTON: "updateButton",
  SAVE_BUTTON: "saveButton",
  EDIT_BUTTON: "editButton",
  EDIT_SENT_RECORD: "editSentRecord",
  CLONE_BUTTON: "cloneButton",
  DELETE_BUTTON: "deleteButton",
  DELETE_NOT_DRAFT_RECORD: "deleteNotDraftRecord",
  CREATE_BUTTON: "createButton",
  CREATE_MASTER_BILL_BUTTON: "createMasterBillButton",
  CREATE_HOUSE_BILL_BUTTON: "createHouseBillButton",
  CREATE_VESSEL_BUTTON: "createVesselButton",
  CREATE_PARTY_BUTTON: "createPartyButton",
  SAVE_SUCCESS_MSG: "saveSuccessMsg",
  UPDATE_SUCCESS_MSG: "updateSuccessMsg",
  DELETE_SUCCESS_MSG: "deleteSuccessMsg",
  DELETE_WARNING_MESSAGE: "deleteWarningMessage",
  OK_DELETE_BUTTON: "okDeleteButton",
  CANCEL_DELETE_BUTTON: "cancelDeleteButton",
  DISCARD_BUTTON: "discardButton",
  SAVE_AND_CONTINUE_BUTTON: "saveAndContinueButton",
  VesselInfo: {
    TITLE: "vesselInfo.title",
    BILL_NO: "vesselInfo.billNo",
    VOYAGE_NUMBER: "vesselInfo.voyageNumber",
    CARRIER_IDENTIFIER: "vesselInfo.carrierIdentifier",
    IMO_NUMBER: "vesselInfo.imoNumber",
    VESSEL_NAME: "vesselInfo.vesselName",
    VESSEL_FLAG_COUNTRY: "vesselInfo.vesselFlagCountry",
    VESSEL_OWNERSHIP_INDICATOR_CODE: "vesselInfo.vesselOwnershipIndicatorCode",
    VESSEL_POWER_TYPE_CODE: "vesselInfo.vesselPowerTypeCode",
    VESSEL_POWER_TYPE_DESCRIPTION: "vesselInfo.vesselPowerTypeDescription",
    VESSEL_LAST_FOREIGN_PORT: "vesselInfo.vesselLastForeignPort",
    VESSEL_FIRST_UAE_PORT: "vesselInfo.vesselFirstUaePort",
    ETD_LAST_FOREIGN_PORT: "vesselInfo.etdLastForeignPort",
    ATD_LAST_FOREIGN_PORT: "vesselInfo.atdLastForeignPort",
    ETA_FIRST_UAE_SEAPORT: "vesselInfo.etaFirstUaeSeaport"
  },
  ContainerDetails: {
    TITLE: "containerDetails.title",
    BILL_NO: "containerDetails.billNo",
    PARENT_BILL_NO: "containerDetails.parentBillNo",
    CONTAINER_NUMBER: "containerDetails.containerNumber",
    CONTAINER_SIZE: "containerDetails.containerSize",
    CONTAINER_LOAD_STATUS: "containerDetails.containerLoadStatus",
    SEAL_IDENTIFIER: "containerDetails.sealIdentifier",
    CONTAINER_STATUS_DESCRIPTION: "containerDetails.containerStatusDescription",
    CONTAINER_VGM: "containerDetails.containerVgm",
    CONTAINER_VGM_UNIT: "containerDetails.containerVgmUnit",
    TEMPERATURE_TYPE: "containerDetails.temperatureType",
    CONTAINER_TEMPERATURE: "containerDetails.containerTemperature",
    TEMPERATURE_MEASUREMENT_CODE: "containerDetails.temperatureMeasurementCode",
    SERVICE_REQUIREMENT_CODE: "containerDetails.serviceRequirementCode",
    CARGO_TYPE: "containerDetails.cargoType",
    SEALING_PARTY_CODE: "containerDetails.sealingPartyCode",
    SEALING_PARTY_NAME: "containerDetails.sealingPartyName",
    SEAL_TYPE: "containerDetails.sealType"
  },
  ConsignmentDetails: {
    TITLE: "consignmentDetails.title",
    BILL_NO: "consignmentDetails.billNo",
    PARENT_BILL_NO: "consignmentDetails.parentBillNo",
    LOCATION_IDENTIFICATION_TYPE: "consignmentDetails.locationIdentificationType",
    CONSIGNMENT_LOCATION: "consignmentDetails.consignmentLocation",
    CONSIGNMENT_LOCATION_NAME: "consignmentDetails.consignmentLocationName",
    TERMINAL_PIER_NAME: "consignmentDetails.terminalPierName",
    MONETARY_AMOUNT_TYPE: "consignmentDetails.monetaryAmountType",
    MONETARY_AMOUNT: "consignmentDetails.monetaryAmount",
    CURRENCY_CODE: "consignmentDetails.currencyCode",
    CHARGE_CATEGORY_CODE: "consignmentDetails.chargeCategoryCode",
    PAYMENT_ARRANGEMENT_CODE: "consignmentDetails.paymentArrangementCode"
  },
  PartiesInfo: {
    TITLE: "partiesInfo.title",
    BILL_NO: "partiesInfo.billNo",
    PARENT_BILL_NO: "partiesInfo.parentBillNo",
    PARTY_TYPE: "partiesInfo.partyType",
    PARTY_IDENTIFICATION_TYPE: "partiesInfo.partyIdentificationType",
    PARTY_ID: "partiesInfo.partyId",
    ESTABLISHMENT_OR_INDIVIDUAL: "partiesInfo.establishmentOrIndividual",
    PARTY_NAME: "partiesInfo.partyName",
    STREET: "partiesInfo.street",
    STREET_NUMBER: "partiesInfo.streetNumber",
    POSTAL_CODE: "partiesInfo.postalCode",
    CITY: "partiesInfo.city",
    COUNTRY: "partiesInfo.country",
    CONTACT_LEVEL: "partiesInfo.contactLevel",
    CONTACT_NAME: "partiesInfo.contactName",
    TELEPHONE_NUMBER: "partiesInfo.telephoneNumber",
    EMAIL_ID: "partiesInfo.emailId",
    URL: "partiesInfo.url",
    FORWARDING_NOTES: "partiesInfo.forwardingNotes"
  },
  GoodsInfo: {
    TITLE: "goodsInfo.title",
    BILL_NO: "goodsInfo.billNo",
    PARENT_BILL_NO: "goodsInfo.parentBillNo",
    CONTAINER_NUMBER: "goodsInfo.containerNumber",
    GOODS_ITEM_NUMBER: "goodsInfo.goodsItemNumber",
    TOTAL_PACKAGE_QUANTITY: "goodsInfo.totalPackageQuantity",
    PACKAGE_TYPE_DESCRIPTION: "goodsInfo.packageTypeDescription",
    GOODS_ITEM_GROSS_WEIGHT: "goodsInfo.goodsItemGrossWeight",
    GROSS_WEIGHT_UNIT_CODE: "goodsInfo.grossWeightUnitCode",
    HS_CODE: "goodsInfo.hsCode",
    GOODS_ITEM_DESCRIPTION: "goodsInfo.goodsItemDescription",
    ADDITIONAL_INFO: "goodsInfo.additionalInfo",
    PACKAGE_TYPE: "goodsInfo.packageType",
    PACKING_DESCRIPTION: "goodsInfo.packingDescription",
    HANDLING_INSTRUCTION_CODE: "goodsInfo.handlingInstructionCode",
    HANDLING_INSTRUCTION_DESC: "goodsInfo.handlingInstructionDesc",
    GOODS_ITEM_NET_WEIGHT: "goodsInfo.goodsItemNetWeight",
    NET_WEIGHT_UNIT_CODE: "goodsInfo.netWeightUnitCode",
    VOLUME: "goodsInfo.volume",
    VOLUME_UNIT_CODE: "goodsInfo.volumeUnitCode",
    PACKING_INSTRUCTIONS_CODE: "goodsInfo.packingInstructionsCode",
    MARKS_AND_LABELS: "goodsInfo.marksAndLabels",
    COUNTRY_OF_ORIGIN: "goodsInfo.countryOfOrigin",
    LOCATION_NAME: "goodsInfo.locationName",
    DG_HAZARD_CLASS_CODES: "goodsInfo.dgHazardClassCodes",
    UNDG_IDENTIFIER: "goodsInfo.undgIdentifier",
    DG_FLASHPOINT_DESC: "goodsInfo.dgFlashpointDesc",
    SHIPMENT_FLASHPOINT_DEGREE: "goodsInfo.shipmentFlashpointDegree",
    FLASHPOINT_UNIT_CODE: "goodsInfo.flashpointUnitCode",
    PACKAGING_DANGER_LEVEL_CODE: "goodsInfo.packagingDangerLevelCode",
    DOES_PACKAGE_TO_BE_SPLIT: "goodsInfo.doesPackageToBeSplit"
  },
  SplitGoods: {
    TITLE: "splitGoods.title",
    BILL_NO: "splitGoods.billNo",
    PARENT_BILL_NO: "splitGoods.parentBillNo",
    GOODS_ITEM_NUMBER: "splitGoods.goodsItemNumber",
    CONTAINER_NUMBER: "splitGoods.containerNumber",
    PACKAGE_QUANTITY: "splitGoods.packageQuantity"
  },
  ValidationMessage: {
    ERROR_MSG_ALPHA_NUMERIC: "validationMessage.errMsgAlphaNumeric",
    ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR: "validationMessage.errMsgAlphaNumericWithSpecialChar",
    ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR_NO_SPACE: "validationMessage.errMsgAlphaNumericWithSpecialCharNoSpace",
    ERROR_MSG_ALPHA_NUMERIC_WITH_HYPEN: "validationMessage.errMsgAlphaNumericWithHypen",
    ERROR_MSG_NUMERIC: "validationMessage.errMsgNumeric",
    ERROR_MSG_MAX_LENGTH: "validationMessage.errMsgMaxLength",
    ERROR_MSG_MIN_LENGTH: "validationMessage.errMsgMinLength"
  }
}

export default UaeMpciKeys
